import { Injectable } from '@angular/core';

import { Product } from '../models/product';
import { ProductOrder } from '../models/product-order';
import { SsOrder } from '../models/selfservice';

import { StorageService } from './storage.service';
import { SelfserviceService } from './selfservice.service';

import { Utils } from '../helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class CartService {
	cart_items: ProductOrder[];
  n_items: number;
  total: number;
  prettyTotal: string;

  useStorage: boolean = true;

  constructor(private storage: StorageService, private ssServ: SelfserviceService) {
  	this.cart_items = storage.getInSession('cart_items') || [];
    this._recalculateValues();
  }

  setUseStorage(useStorage: boolean) {
    this.useStorage = useStorage;
  }

  clear() {
    this.cart_items = [];
    this.n_items = 0;
    this.total = 0;
    this.prettyTotal = "0,00";
    if(this.useStorage) {
      this.storage.removeInSession('cart_items');
      this.storage.removeInSession('cart_total');
      this.storage.removeInSession('cart_pretty_total');
    }
  }

  recalculate() {
    this._recalculateValues();
  }

  setItems(items: ProductOrder[]) {
    for(let item of items) {
      ProductOrder.setAdditionalData(item);
    }
    this.cart_items = items;
    this._recalculateValues();

    if(this.useStorage)
      this.storage.storeInSession('cart_items', this.cart_items);
  }
  addItem(item: ProductOrder) {
    item.id = -Math.floor(Math.random()*20000);
    ProductOrder.setAdditionalData(item);
  	this.cart_items.push(item);
    this._recalculateValues();
  	this._storeItems();
  }
  removeItem(item: ProductOrder) {
    let found: ProductOrder = Utils.findById(item.id, this.cart_items);
    
    let index = this.cart_items.indexOf(found);
    this.cart_items.splice(index, 1);
    this._recalculateValues();
    this._storeItems();
  }
  changeQuantity(item: ProductOrder) {
    let found: ProductOrder = Utils.findById(item.id, this.cart_items);
    found.quantity = item.quantity;
    ProductOrder.setAdditionalData(found);
    this._recalculateValues();
    this._storeItems();
  }

  getItems(): ProductOrder[] {
  	this.cart_items = this.useStorage ? this.storage.getInSession('cart_items') || [] : this.cart_items;
    return Utils.clone(this.cart_items);
  }
  getTotal(): number {
    return this.useStorage ? this.storage.getInSession('cart_total') : this.total;
  }
  getPrettyTotal(): string {
    return this.useStorage ? this.storage.getInSession('cart_pretty_total') : this.prettyTotal;
  }

  storeLocalOrder(order: SsOrder) {
    let cur = {orders: []};
    let curStr = this.storage.getInLocal(this.ssServ.code);
    
    if(curStr) {
      cur = JSON.parse(curStr);
    }

    cur.orders.push(order);
    // expire after 2 days
    this.storage.storeInLocal(this.ssServ.code, cur, 60*60*24*2);
  }
  getLocalOrders(): SsOrder[] {
    let cur = this.storage.getInLocal(this.ssServ.code);
    if(cur && cur.orders) {
      return cur.orders;
    } else {
      return [];
    }
  }

  private _recalculateValues() {
    this.n_items = this.cart_items.length;
    this.total = 0;
    for(let item of this.cart_items) {
      this.total += Number(item.get_price);
    }
    this.total = Number(this.total.toFixed(2));
    this.prettyTotal = this.total.toFixed(2).replace('.',',');

    if(this.useStorage) {
      this.storage.storeInSession('cart_total', this.total);
      this.storage.storeInSession('cart_pretty_total', this.prettyTotal);
    }
  }
  private _storeItems() {
    if(this.useStorage)
      this.storage.storeInSession('cart_items', this.cart_items);
  }
}
